import { NotificationFactory } from "@/components/PushManager";
type PushSubscriber = (sendNotification: NotificationFactory) => void;

const context = require.context("./", true, /[a-zA-Z]\/index.ts/);

export default context.keys().reduce<PushSubscriber[]>((out, key) => {
  const module = context(key);
  out.push(module.default);
  return out;
}, []);
